import { QueryClient } from 'react-query';
const queryClient = new QueryClient();

// This makes it easier to mock/spy versus just exporting the constant
export const getQueryClient = (): QueryClient => queryClient;
